App.addModule(function(app) {

    cm = {

        version: app.get('app.consent.version'),

        triggered: {},

        services: {},

        init: function() {
			
			if (document.cookie.indexOf("consent=") === 0 || document.cookie.indexOf("; consent=") !== -1) {
				
	            this.loadCookie()
			}
			else {
				
				this.setCookie()
			}
			
			for (const [name, service] of Object.entries(this.services)) {
                service.consent && this.triggerCallbacks(name)
            }
			
			app.dispatchEvent('consent:load')
        },

        addService: function(name, consent) {
            
            if (name in this.services) {
                this.services[name].consent = consent
            }
            else {
                this.services[name] = {
                    consent: consent,
                    callbacks: []
                }
            }

            return this
        },

        addCallback: function(name, callback) {

            if (name in this.services) {

                if (this.services[name].consent) {

                    this.executeCallback(callback)
                }
                else {
                    this.services[name].callbacks.push(callback)
                }
            }

            return this
        },

        triggerCallbacks: function(name) {

            if (!(name in this.triggered)) {

                this.triggered[name] = true

                this.services[name].callbacks.forEach(callback => {
                    this.executeCallback(callback)
                })
            }

            return this
        },

        executeCallback: function(callback) {

            try {
                callback()
            } catch (e) {
                this.logException(e)
            }

            return this
        },

        logException: function(e) {

            app.logException(e)

            return this
        },

        set: function(name, consent) {

            if ("*" === name) {

                Object.keys(this.services).forEach(name => {
					this.services[name].consent = consent
                })

                return this
            }

            if (name in this.services) {
                this.services[name].consent = consent
            }

            return this
        },

        get: function(name) {
            return name in this.services && this.services[name].consent
        },

        loadCookie: function() {

            document.cookie.split("; ").forEach(cookie => {

                if (cookie.indexOf("consent=") === 0) {

                    const value = JSON.parse(cookie.substring(8, cookie.length))

                    for (const [name, consent] of Object.entries(value)) {

                        if (name !== '_v') {
                            this.set(name, consent)
                        }
                    }
                }
            })

            return this
        },
		
		setCookie: function() {
			
            const value = {
                _v: this.version
            }

            for (const [name, service] of Object.entries(this.services)) {
                value[name] = service.consent ? 1 : 0
            }

            const t = new Date()

            t.setTime(t.getTime() + 31536e6)

            document.cookie = "consent=" + JSON.stringify(value) + "; expires=" + t.toUTCString() + "; path=/"
			
			return this
		},

        save: function() {

			this.setCookie()
			
			for (const [name, service] of Object.entries(this.services)) {
				service.consent && this.triggerCallbacks(name)
			}
			
            app.dispatchEvent('consent:save')

            return this
        }
    }

    for (const [name, consent] of Object.entries(app.get('app.consent.services', {}))) {
        cm.addService(name, consent)
    }

    cm.init()

    app.on('loaded', () => {
	    
	    var basic = $('#modal-consentmanager')
		    extended = $('#modal-consentmanager-extended');
	    
	    basic.modal({
		    backdrop: 'static',
		    keyboard: false,
		    show: false
	    });
	    
	    extended.modal({
		    backdrop: 'static',
		    keyboard: false,
		    show: false
	    });
	    
	    basic.find('#cm-save-all').on('click', '', function() {
		    cm.set('*', true);
		    cm.save();
		    basic.modal('hide');
	    });
	    
	    basic.find('#cm-settings-open').on('click', '', function() {
		    basic.modal('hide');
		    extended.modal('show');
	    });
	    
		Object.keys(cm.services).forEach(name => {
			extended.find('input[name="'+ name +'"]').prop('checked', cm.get(name))
		})
	    
	    extended.find('#cm-save-settings').on('click', '', function() {
		    
		    extended.find('input').each(function() {
			    
			    var name = $(this).attr('name'),
				    consent = $(this).prop('checked');
			    
			    cm.set(name, consent);
			    
			    extended.modal('hide');
		    });
		    
		    cm.save();
	    });
	    
	    if (app.get('app.consent.show')) {
		    basic.modal('show');
	    }
    })
})
